var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1650 4368 c-18 -13 -41 -34 -51 -48 -10 -14 -76 -253 -152 -550 -118 -461 -132 -526 -118 -532 9 -5 247 -67 530 -139 541 -138 557 -140 611 -101 93 69 93 195 0 263 -14 11 -140 48 -280 84 -140 36 -264 69 -274 73 -16 7 -2 17 75 54 221 107 458 151 684 128 128 -13 167 -21 292 -62 370 -119 680 -426 803 -796 50 -149 64 -242 64 -407 1 -229 -38 -396 -137 -589 -178 -348 -496 -588 -890 -673 -115 -25 -380 -25 -496 0 -126 27 -224 63 -341 123 -345 178 -578 489 -667 884 -12 54 -17 129 -18 266 -2 221 -8 242 -85 282 -56 29 -117 24 -168 -14 -50 -39 -63 -80 -69 -223 -30 -681 383 -1308 1027 -1556 357 -138 783 -138 1140 0 802 309 1216 1186 945 2000 -169 511 -596 910 -1112 1039 -156 39 -248 50 -413 49 -251 -1 -483 -54 -692 -159 -50 -25 -88 -39 -88 -32 0 6 27 118 61 247 65 251 68 290 31 340 -33 46 -81 71 -132 71 -32 0 -57 -7 -80 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.8eb1bed80aae90c54d7bc2bfcaa276d3.svg";
export { ForwardRef as ReactComponent };